import { createApi } from '@reduxjs/toolkit/query/react';
import { API, API_PREFIX } from '../../constants';
import { baseQuery } from './base.query';
import { FilterListEntry } from '../../models/filter.model';

interface TeamMemberSearch {
  teamIds: string[];
  searchQuery?: string;
  withActivities?: boolean;
}

export const teamsApi = createApi({
  reducerPath: 'teamsApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    searchTeamMember: builder.query<FilterListEntry[], TeamMemberSearch>({
      query: (args) => ({
        url:
          `${API_PREFIX.NEXTGEN}${API.TEAMS}/members?teamIds=${args.teamIds.join(',')}` +
          (args.searchQuery ? `&searchCriteria=${args.searchQuery}` : '') +
          (args.withActivities ? `&withActivities=${args.withActivities}` : ''),
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSearchTeamMemberQuery } = teamsApi;
